import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper } from "@mui/material";
import { DAY_NIGHT_TEXT_COLOR, WeatherAlert } from "../types/Weather";
import { useLocationWeatherContext } from "../contexts/LocationWeatherContext";
import { WarningAmber } from "@mui/icons-material";
import TodayWeatherAlertsBottomDrawer from "./TodayWeatherAlertsBottomDrawer";
import { useState } from "react";

const TodayWeatherAlertsSection = () => {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [alertIndex, setAlertIndex] = useState<number | undefined>();
  const { weatherAlerts } = useLocationWeatherContext();

  // console.log("weatherAlerts:", weatherAlerts);

  const openDrawer = (alertIndex: number) => {
    setAlertIndex(alertIndex);
    setDrawerOpen(true);
  }

  const WeatherAlertListItem = ({ weatherAlert, weatherAlertIndex }: { weatherAlert: WeatherAlert, weatherAlertIndex: number }) => {
    return (
      <>
        <ListItem disablePadding>
          <ListItemButton disableGutters onClick={() => openDrawer(weatherAlertIndex)}>
            <ListItemIcon sx={{ minWidth: '30px' }} >
              <WarningAmber color="error" />
            </ListItemIcon>
            <ListItemText primary={weatherAlert.description} />
          </ListItemButton>
        </ListItem>
      </>
    );
  }

  return (
    weatherAlerts.length > 0
      ?
      <Paper sx={{
        borderRadius: '16px',
        marginTop: 2,
        paddingY: 0.005,
        paddingX: 2,
        backgroundColor: DAY_NIGHT_TEXT_COLOR,
        opacity: 0.85,
      }}>
        <List >
          {
            weatherAlerts.map((eachAlert, i) => (
              <WeatherAlertListItem weatherAlert={eachAlert} weatherAlertIndex={i} key={i} />
            ))
          }
        </List>
        <TodayWeatherAlertsBottomDrawer
          weatherAlerts={weatherAlerts}
          weatherAlertIndex={alertIndex}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen} />
      </Paper>
      :
      <></>);
}

export default TodayWeatherAlertsSection;